import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { ILoginCheckPostResponse } from './auth.model';
import { AuthService } from './auth.service';

@Component({
  selector: 'ai-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit, OnDestroy {
  @Input() aud: string[];

  loginForm: FormGroup;
  isAuthenticating: boolean;
  backendError: any;
  authError$: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {}

  loginWithFacebook(authorizationUrl: string) {
    location.href = `${authorizationUrl}&success_url=${location.origin}&failure_url=${location.origin}/auth`;
  }

  loginWithForm() {
    if (this.loginForm.valid) {
      this.backendError = null;
      this.isAuthenticating = true;

    this.authService.loginCheck({
      username: this.loginForm.value.username,
      password: this.loginForm.value.password,
      aud: this.aud
    }).pipe(
        catchError((err: any) => {
          this.backendError = err;
          return throwError(err);
        }),
        finalize(() => this.isAuthenticating = false),
      ).subscribe((response: ILoginCheckPostResponse) => {
        localStorage.setItem('jwt', response.token);
        this.router.navigate(['/']);
      });
    }
  }

  logout () {
    this.authService.logout();
  }

  ngOnInit() {
    this.authError$ = this.authService.getAuthError$();
    this.loginForm  = this.fb.group({
      username: [null, [Validators.required, Validators.maxLength(180)]],
      password: [null, [Validators.required, Validators.maxLength(255)]]
    });
  }

  ngOnDestroy() {
    this.authService.setAuthError(null);
  }
}
